module.exports = __webpack_public_path__ + "static/img/nav_bg.163b9867.png";